import { ControlledInputs, PrimaryButton } from '@/components';
import { Stack } from '@mui/material';
import { useManageCreditForm, useManageCreditFormContext } from '../hooks';
import { useTableCheckIds } from '../store';
import { useFormContext } from 'react-hook-form';

export const FormField = () => {
  const checked = useTableCheckIds();
  const { control, setValue, getValues } = useManageCreditFormContext();

  return (
    <Stack
      py={3}
      gap={4}
      flexDirection={checked.length > 1 ? 'column' : 'column-reverse'}
    >
      <Stack direction="row" gap={2} alignItems="center">
        <ControlledInputs.Select
          ControllerProps={{
            control,
            name: 'type',
          }}
          placeholder="Select type (reward, grant, adjustment)"
          options={[
            { name: 'Reward / Grant', value: 'credit_addition' },
            { name: 'Adjustment / Deduction', value: 'credit_deduction' },
          ]}
          optionKeys={{
            value: 'value',
            label: 'name',
          }}
        />
        <Stack direction="row" gap={1} justifyContent="flex-end">
          <PrimaryButton
            onClick={() => {
              const currentAmount = getValues('amount') ?? 0;
              setValue('amount', currentAmount - 1);
            }}
          >
            <svg
              width="21"
              height="20"
              viewBox="0 0 22 20"
              fill="none"
              style={{ marginLeft: -4, marginTop: -4 }}
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5.5 12H19.5"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </PrimaryButton>
          <ControlledInputs.NumberField
            ControllerProps={{
              control,
              name: 'amount',
            }}
            sx={{ width: 60 }}
          />
          <PrimaryButton
            onClick={() => {
              const currentAmount = getValues('amount') ?? 0;
              setValue('amount', currentAmount + 1);
            }}
          >
            <svg
              width="21"
              height="20"
              viewBox="0 0 21 20"
              fill="none"
              style={{ marginLeft: -4, marginTop: -4 }}
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5.5 12H19.5M12.5 5V19"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </PrimaryButton>
        </Stack>
      </Stack>
      <ControlledInputs.Textarea
        ControllerProps={{
          control,
          name: 'description',
        }}
        placeholder="Reason or note"
        minRows={6}
      />
    </Stack>
  );
};
